export const SET_UPDATE_PERMISSIONS = "SET_UPDATE_PERMISSIONS";
export const SET_CURRENT_PERMISSIONS = "SET_CURRENT_PERMISSIONS";
export const SET_PERMISSIONS_LIST = "SET_PERMISSIONS_LIST";
export const SET_ALL_PERMISSIONS_LIST = "SET_ALL_PERMISSIONS_LIST";
